import { NavMain } from "@/components/dashboard/NavMain";
import { NavUser } from "@/components/dashboard/NavUser";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/Sidebar";
import { sideData } from "@/constant/navbar";
import { QUERY_KEY } from "@/constant/queryKey";
import { usePagination } from "@/hooks/use-pagination";
import {
  ADMIN_MERCHANT_ENDPOINT,
  AdminMerchant,
} from "@/services/core/admin-merchant.api";
import { useMerchantStore } from "@/store/merchant-store";
import { Command, UserRound } from "lucide-react";
import * as React from "react";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { data: merchants } = usePagination<AdminMerchant>({
    endpoint: ADMIN_MERCHANT_ENDPOINT,
    queryKey: QUERY_KEY.ADMIN_MERCHANT,
    initialParams: {
      currentPage: 1,
      pageSize: 10,
    },
  });
  const { selectedMerchant, setSelectedMerchant } = useMerchantStore();

  return (
    <Sidebar
      className="top-(--header-height) h-[calc(100svh-var(--header-height))]! p-3"
      {...props}
    >
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <div className="bg-sidebar-accent text-sidebar-accent-foreground flex items-center gap-2 rounded-xl px-2 py-2">
              <div className="bg-sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
                <Command className="size-4" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">
                  Payment Gateway Portal
                </span>
              </div>
            </div>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarGroup>
        <SidebarGroupLabel>Merchants</SidebarGroupLabel>
        <Select
          value={selectedMerchant?.id}
          onValueChange={(value) => {
            const merchant = Array.isArray(merchants)
              ? merchants.find((m) => m.id === value)
              : undefined;
            if (merchant) {
              setSelectedMerchant({
                id: merchant.id,
                name: merchant.username,
              });
            }
          }}
        >
          <SelectTrigger className="w-full cursor-pointer border-0 shadow-none">
            <div className="flex gap-2">
              <UserRound />
              <SelectValue
                placeholder="Select a merchant"
                className="justify-start"
              />
            </div>
          </SelectTrigger>
          <SelectContent>
            {Array.isArray(merchants) && merchants.length > 0 ? (
              merchants.map((merchant) => (
                <SelectItem key={merchant.id} value={merchant.id}>
                  {merchant.username}
                </SelectItem>
              ))
            ) : (
              <p className="text-sm ml-2">No merchants found</p>
            )}
          </SelectContent>
        </Select>
      </SidebarGroup>
      <SidebarContent>
        <NavMain items={sideData.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  );
}
